import React from 'react';
import { SITE_NAME, BRAND_COLOR, INSTAGRAM_URL } from '../constants';

const Footer: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => (
  <footer className={`py-20 border-t transition-colors duration-500 ${isDarkMode ? 'bg-black border-white/5 text-zinc-600' : 'bg-white border-zinc-200 text-zinc-400'}`}>
    <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-12">
      <div className="text-[12px] font-black uppercase tracking-[0.5em] order-2 md:order-1">
        <p>{SITE_NAME.toLowerCase()} 2025</p>
      </div>

      <div className="flex flex-col items-center gap-6 order-1 md:order-2">
        <a 
          href={INSTAGRAM_URL} 
          target="_blank" 
          rel="noopener noreferrer"
          className="group flex flex-col items-center gap-4 transition-all"
        >
          <div 
            className="w-16 h-16 rounded-full flex items-center justify-center border-2 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-12" 
            style={{ borderColor: BRAND_COLOR }}
          >
            <svg 
              width="24" height="24" viewBox="0 0 24 24" fill="none" 
              stroke={BRAND_COLOR} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </div>
          <span className="text-[10px] font-black tracking-[0.4em] uppercase text-brand opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0">
            CONNECT
          </span>
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;